import React, { useEffect, useState } from 'react';
// import Filters from '../Filters';
import Filters from '../../Components/Filters';
import ConsultancyItem from './ConsultancyItem';

function Consultancy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    let consultancy = [
        {
            name: "pratik Gandhi",
            teacher_type: "Community Tutor",
            speaks: ["Hindi", "English"],
            trial_rate: 450,
            hourly_rate: 870,
            teacher_from: "India",
            category: "Job interview"
        },
        {
            name: "Histol Kee",
            teacher_type: "Community Tutor",
            speaks: ["Portuguese", "Spanish"],
            trial_rate: 100,
            hourly_rate: 280,
            teacher_from: "Brasil",
            category: "Carrier adviser"
        },
        {
            name: "Akash Raj",
            teacher_type: "Community Tutor",
            speaks: ["Hindi", "English"],
            trial_rate: 150,
            hourly_rate: 360,
            teacher_from: "India",
            category: "Job interview"
        },
        {
            name: "Ablo langen",
            teacher_type: "Community Tutor",
            speaks: ["Portuguese", "Spanish"],
            trial_rate: 200,
            hourly_rate: 450,
            teacher_from: "Brasil",
            category: "conversation practice"
        },
        {
            name: "Sahil Saif",
            teacher_type: "Professional teacher",
            speaks: ["Hindi", "English"],
            trial_rate: 450,
            hourly_rate: 900,
            teacher_from: "India",
            category: "Carrier adviser"
        },
        {
            name: "Simi Smith",
            teacher_type: "Community Tutor",
            speaks: ["French", "English"],
            trial_rate: 100,
            hourly_rate: 650,
            teacher_from: "USA",
            category: "presentation"
        },
        {
            name: "Mia Mani",
            teacher_type: "Community Tutor",
            speaks: ["French", "English"],
            trial_rate: 120,
            hourly_rate: 580,
            teacher_from: "France",
            category: "conversation practice"
        },
        {
            name: "Suraj chaudhary",
            teacher_type: "Professional teacher",
            speaks: ["Hindi", "English"],
            trial_rate: 500,
            hourly_rate: 1100,
            teacher_from: "India",
            category: "presentation"
        },
        {
            name: "Lan Banton",
            teacher_type: "Community Tutor",
            speaks: ["English", "Portuguese"],
            trial_rate: 360,
            hourly_rate: 660,
            teacher_from: "UK",
            category: "Carrier adviser"
        },
        {
            name: "Tomas Crus",
            teacher_type: "Community Tutor",
            speaks: ["English", "Spanish"],
            trial_rate: 450,
            hourly_rate: 920,
            teacher_from: "USA",
            category: "presentation"
        },
        {
            name: "Doland Grek",
            teacher_type: "Professional teacher",
            speaks: ["French", "English"],
            trial_rate: 660,
            hourly_rate: 1200,
            teacher_from: "France",
            category: "Carrier adviser"
        },
        {
            name: "Lola Roy",
            teacher_type: "Professional teacher",
            speaks: ["French", "Spanish"],
            trial_rate: 760,
            hourly_rate: 1400,
            teacher_from: "France",
            category: "presentation"
        },
        {
            name: "Ana Smith",
            teacher_type: "Professional teacher",
            speaks: ["English", "Spanish"],
            trial_rate: 260,
            hourly_rate: 800,
            teacher_from: "UK",
            category: "Carrier adviser"
        },
    ]
    const [availableConsultancy, setavailableConsultancy] = useState(consultancy)

    let handleFiltering = (heading, data) => {
        switch (heading) {
            case "Category":
                if (data == "All") {
                    setavailableConsultancy(consultancy)
                }
                else {
                    let category_items = consultancy.filter(i => i.category == data);
                    setavailableConsultancy(category_items);
                    console.log(availableConsultancy)
                }
                break
            case "Teacher From":
                let countryWiseItem = consultancy.filter(i => i.teacher_from == data);
                setavailableConsultancy(countryWiseItem)
                break
            case "Teacher Type":
                let teacherTypeItem = consultancy.filter(i => i.teacher_type == data);
                setavailableConsultancy(teacherTypeItem)
                break
            case "Price Range":
                console.log(data);
                let priceWiseItem = consultancy.filter(i => i.hourly_rate >= data[0] && i.hourly_rate <data[1]);
                console.log(priceWiseItem)
                setavailableConsultancy(priceWiseItem)
                break
            case "Language":
                let LanguageWiseItem = consultancy.filter(i => i.speaks.find(j => j == data));
                setavailableConsultancy(LanguageWiseItem)
                break
            default:
                break;
        }
    }
    return (
        <div className="container " style={{ marginTop: "10%" }} >
            <div className="d-flex justify-content-center">
                <Filters handleFiltering={handleFiltering} heading="Category" options={["All", "Carrier adviser", "conversation practice", "presentation", "Job interview"]} />
                <Filters handleFiltering={handleFiltering} heading="Country" options={["India", "France", "UK", "USA", "Brasil"]} />
                <Filters handleFiltering={handleFiltering} heading="Teacher Type" options={["Professional teacher", "Community Tutor"]} />
                <Filters handleFiltering={handleFiltering} heading="Price Range" maxRange={1500} minRange={0} dis={200} intitialrange={[200,800]}/>
                <Filters handleFiltering={handleFiltering} heading="Language" options={["English", "French", "Spanish", "Portuguese", "Hindi"]} />
                {/* <Filters/> */}
                
            </div>
            {
                availableConsultancy.map((item) => {
                    return <ConsultancyItem details={item} />;
                })

            }
        </div>
    )
}

export default Consultancy;
